import { NgModule } from "@angular/core";
import { TagSelectorComponent } from "ng/src/app/tags/tag-selector.component";
import { SharedModule } from "primeng/api";
import { ChipsModule } from "primeng/chips";
import { MultiSelectModule } from "primeng/multiselect";
import { ChipModule } from "primeng/chip";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { AutoCompleteModule } from "primeng/autocomplete";

@NgModule({
	imports: [
		CommonModule,
		SharedModule,
		ChipsModule,
		MultiSelectModule,
		ChipModule,
		FormsModule,
		ReactiveFormsModule,
		AutoCompleteModule
	],
	declarations: [
		TagSelectorComponent
	],
	exports: [
		TagSelectorComponent
	]
})
export class TagsModule {}